export default __webpack_public_path__ + "static/media/9.fea27462.jpg";